import jq from 'json-query'

export function mapPractitionersToForm (practitioners) {
  return practitioners.reduce((acc, practitioner) => {
    if (practitioner.identifier) {
      const { id, active } = practitioner
      const given = jq('name[0].given[0]', { data: practitioner }).value
      const family = jq('name[0].family[0]', { data: practitioner }).value
      const suffix = jq('name[0].suffix[0]', { data: practitioner })?.value
      const role = jq('role', { data: practitioner }).value
      const phone =
        practitioner.telecom.filter(ph => ph.system === 'phone') || null
      acc.push({
        id,
        active,
        display: `${given} ${family}${suffix ? `, ${suffix}` : ''}`,
        role,
        phone
      })
    }
    return acc
  }, [])
}
